var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiaTax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM8.35288 9.31699C9.07032 9.7312 9.98771 9.48539 10.4019 8.76795C10.8161 8.05051 10.5703 7.13313 9.85288 6.71891C9.13544 6.3047 8.21806 6.55051 7.80384 7.26795C7.38963 7.98539 7.63544 8.90278 8.35288 9.31699ZM15.616 7.73686L13.884 6.73686L8.38398 16.2631L10.116 17.2631L15.616 7.73686ZM16.1962 16.732C15.782 17.4494 14.8646 17.6953 14.1471 17.281C13.4297 16.8668 13.1839 15.9494 13.5981 15.232C14.0123 14.5146 14.9297 14.2687 15.6471 14.683C16.3646 15.0972 16.6104 16.0146 16.1962 16.732Z",
    fill: "#1A1B1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiaTax);
export default __webpack_public_path__ + "static/media/lia-tax.8b9bfc4ecb50cdc60fd03ffed7d6dfc8.svg";
export { ForwardRef as ReactComponent };